module.exports = __webpack_public_path__ + "media/components/country-flag/static/es-ct-19adb496d3fbdb06269fda508d3fdbcd.svg";